
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/user",
      function () {
        return require("private-next-pages/user/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/user"])
      });
    }
  